import _slicedToArray from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { deg2rad as t } from "../../../../core/mathUtils.js";
import { isSome as i, isNone as e } from "../../../../core/maybe.js";
import { f as s, i as n, k as r } from "../../../../chunks/vec2.js";
import { a as h } from "../../../../chunks/vec2f64.js";
import { r as a, d as o, o as c, c as _, n as l, b as p, a as d, z as g, g as f } from "../../../../chunks/vec3.js";
import { c as u, f as m } from "../../../../chunks/vec3f64.js";
import { create as D, fromPositionAndNormal as x, signedDistance as b, copy as V, intersectLine as y, normal as N } from "../../../../geometry/support/plane.js";
import { angle as P, projectPointSignedLength as j } from "../../../../geometry/support/vector.js";
import { intersectLineAndRay as v } from "../../../support/geometry2dUtils.js";

var z = /*#__PURE__*/function () {
  function z(t, i, e) {
    var s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var n = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;

    _classCallCheck(this, z);

    this.helper = t, this.planeType = i, this.edge = e, this.distance = s, this._plane = D(), this._offsetPlane = D(), this._minDistance = -1 / 0, this._maxDistance = 1 / 0, 0 === n && this._initialize();
  }

  _createClass(z, [{
    key: "plane",
    get: function get() {
      return this._plane;
    }
  }, {
    key: "requiresSplitEdgeLeft",
    get: function get() {
      return !this._left.isOriginalDirection;
    }
  }, {
    key: "requiresSplitEdgeRight",
    get: function get() {
      return !this._right.isOriginalDirection;
    }
  }, {
    key: "edgeDirection",
    get: function get() {
      return this._edgeDirection;
    }
  }, {
    key: "_initialize",
    value: function _initialize() {
      this._initializeNeighbors(), this._initializePlane(), this._initializeDistanceConstraints();
    }
  }, {
    key: "_initializeNeighbors",
    value: function _initializeNeighbors() {
      var t, i, e, s;

      var n = this._toXYZ(this.edge.leftVertex.pos),
          r = this._toXYZ(null == (t = this.edge.leftVertex.leftEdge) || null == (i = t.leftVertex) ? void 0 : i.pos),
          h = this._toXYZ(this.edge.rightVertex.pos),
          o = this._toXYZ(null == (e = this.edge.rightVertex.rightEdge) || null == (s = e.rightVertex) ? void 0 : s.pos);

      this._edgeDirection = a(u(), n, h), this._left = this._computeNeighbor(n, r, this._edgeDirection), this._right = this._computeNeighbor(h, o, this._edgeDirection);
    }
  }, {
    key: "_toXYZ",
    value: function _toXYZ(t) {
      return i(t) ? this.helper.toXYZ(t) : null;
    }
  }, {
    key: "_computeNeighbor",
    value: function _computeNeighbor(t, i, s) {
      if (e(i)) return {
        start: t,
        end: i,
        direction: m(-s[1], s[0], 0),
        isOriginalDirection: !0
      };
      var n = a(u(), t, i),
          r = !this._passesBisectingAngleThreshold(n, s);
      return {
        start: t,
        end: i,
        direction: r ? this._bisectVectorsPerpendicular(s, n) : n,
        isOriginalDirection: !r
      };
    }
  }, {
    key: "_passesBisectingAngleThreshold",
    value: function _passesBisectingAngleThreshold(t, i) {
      var e = Math.abs(P(i, t));
      return e >= E && e <= Math.PI - E;
    }
  }, {
    key: "_bisectVectorsPerpendicular",
    value: function _bisectVectorsPerpendicular(t, i) {
      var e = o(t, i) < 0 ? t : c(u(), t),
          s = Math.abs(o(e, i));
      if (!(s < .001 || s > .999)) return this._bisectDirection(e, i);

      var n = _(u(), e, [0, 0, 1]);

      return l(n, n);
    }
  }, {
    key: "_bisectDirection",
    value: function _bisectDirection(t, i) {
      var e = p(u(), t, i);
      return l(e, e);
    }
  }, {
    key: "_initializePlane",
    value: function _initializePlane() {
      var t = this._computeNormalDirection(this._left),
          i = this._computeNormalDirection(this._right);

      o(t, i) < 0 && c(i, i), x(this._left.start, this._bisectDirection(t, i), this._plane);
    }
  }, {
    key: "_computeNormalDirection",
    value: function _computeNormalDirection(t) {
      var i = _(u(), t.direction, this._edgeDirection);

      l(i, i);

      var e = _(u(), this._edgeDirection, i);

      return 1 === this.planeType && (e[2] = 0), l(e, e);
    }
  }, {
    key: "_initializeDistanceConstraints",
    value: function _initializeDistanceConstraints() {
      i(this._left.end) && !this.requiresSplitEdgeLeft && this._updateDistanceConstraint(b(this._plane, this._left.end)), i(this._right.end) && !this.requiresSplitEdgeRight && this._updateDistanceConstraint(b(this._plane, this._right.end)), this._updateIntersectDistanceConstraint(this._plane);
    }
  }, {
    key: "_updateDistanceConstraint",
    value: function _updateDistanceConstraint(t) {
      t <= 0 && (this._minDistance = Math.max(this._minDistance, t)), t >= 0 && (this._maxDistance = Math.min(this._maxDistance, t));
    }
  }, {
    key: "_updateIntersectDistanceConstraint",
    value: function _updateIntersectDistanceConstraint(t) {
      var i = N(t),
          e = this._edgeDirection,
          a = p(u(), this._left.start, this._left.direction),
          o = p(u(), this._right.start, this._right.direction),
          c = this._pointInBasis2D(h(), i, e, this._left.start),
          _ = this._pointInBasis2D(h(), i, e, a),
          l = this._pointInBasis2D(h(), i, e, this._right.start),
          g = this._pointInBasis2D(h(), i, e, o),
          _v = v({
        start: _,
        end: c,
        type: 1
      }, {
        start: g,
        end: l,
        type: 1
      }),
          _v2 = _slicedToArray(_v, 1),
          f = _v2[0];

      if (!f) return;
      var m = s(h(), c, _);
      n(m, m);
      var D = s(h(), f, _),
          x = r(m, D),
          V = p(u(), a, d(u(), this._left.direction, -x)),
          y = b(t, V);

      this._updateDistanceConstraint(y);
    }
  }, {
    key: "_pointInBasis2D",
    value: function _pointInBasis2D(t, i, e, s) {
      return t[0] = j(i, s), t[1] = j(e, s), t;
    }
  }, {
    key: "_offset",
    value: function _offset(t, e) {
      var _this = this;

      Number.isFinite(this._minDistance) && (e = Math.max(this._minDistance, e)), Number.isFinite(this._maxDistance) && (e = Math.min(this._maxDistance, e)), V(this._plane, this._offsetPlane), this._offsetPlane[3] -= e;

      var s = function s(t, e, _s) {
        return i(e) && y(_this._offsetPlane, t, p(u(), t, e), _s);
      },
          n = u();

      (t === this.edge.leftVertex ? s(this._left.start, this._left.direction, n) : s(this._right.start, this._right.direction, n)) && this.helper.copy(this.helper.fromXYZ(n, void 0, this.helper.getM(t.pos)), t.pos);
    }
  }, {
    key: "signedDistanceToPoint",
    value: function signedDistanceToPoint(t) {
      return b(this.plane, this.helper.toXYZ(this.helper.pointToVector(t)));
    }
  }, {
    key: "apply",
    value: function apply(t) {
      this._offset(t, this.distance);
    }
  }, {
    key: "undo",
    value: function undo(t) {
      this._offset(t, 0);
    }
  }, {
    key: "canAccumulate",
    value: function canAccumulate(t) {
      return t instanceof z && this.edge.leftVertex.index === t.edge.leftVertex.index && this.edge.rightVertex.index === t.edge.rightVertex.index && this.edge.component === t.edge.component && this._maybeEqualsVec3(this._left.direction, t._left.direction) && this._maybeEqualsVec3(this._right.direction, t._right.direction) && g(N(this._plane), N(t._plane));
    }
  }, {
    key: "accumulate",
    value: function accumulate(t, i) {
      var e = this._plane[3] - i._plane[3] + i.distance;

      this._offset(t, e);
    }
  }, {
    key: "accumulateParams",
    value: function accumulateParams(t) {
      var i = t.distance - t._plane[3];
      this.distance = i + this._plane[3];
    }
  }, {
    key: "clone",
    value: function clone() {
      var t = new z(this.helper, this.planeType, this.edge, this.distance, 1);
      return V(this._plane, t._plane), V(this._offsetPlane, t._offsetPlane), t._maxDistance = this._maxDistance, t._minDistance = this._minDistance, t._left = this._cloneNeighbor(this._left), t._right = this._cloneNeighbor(this._right), t._edgeDirection = f(u(), this._edgeDirection), t;
    }
  }, {
    key: "_maybeEqualsVec3",
    value: function _maybeEqualsVec3(t, s) {
      return e(t) && e(s) || i(t) && i(s) && g(t, s);
    }
  }, {
    key: "_cloneNeighbor",
    value: function _cloneNeighbor(_ref) {
      var t = _ref.start,
          e = _ref.end,
          s = _ref.direction,
          n = _ref.isOriginalDirection;
      return {
        start: f(u(), t),
        end: i(e) ? f(u(), e) : null,
        direction: f(u(), s),
        isOriginalDirection: n
      };
    }
  }]);

  return z;
}();

var E = t(15);
export { z as OffsetEdgeVertex };